module.exports = __webpack_public_path__ + "media/images/registration_yucho_card_and_note-3e88e0a9998af087ed1375339e4df9d1.png";